import { render, staticRenderFns } from "./ActivarCuenta.vue?vue&type=template&id=c6a26170&"
import script from "./ActivarCuenta.vue?vue&type=script&lang=js&"
export * from "./ActivarCuenta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports